<section id="services">
    <!-- Section Header -->
    <div class="box-light">
        <div class="wrapper padding-all">
            <div class="section-header inline">
                <h2 class="letter-spacing line-bottom left ">कृपया तुमचा अभिप्राय आमच्याशी शेअर करा.</h2>
                <h5 class="letter-spacing">तुमची मते आमच्यासाठी खूप मौल्यवान आहेत. तुम्हाला आमच्या सर्वोत्तम सेवा पुरवण्यासाठी, तुम्ही आमची उत्पादने आणि सेवांविषयी तुमची मते/सूचना देऊ शकता.</h5>
                <!-- <a href="#" class="btn btn-default v-center">REQUEST A QUOTE</a> -->
            </div>
        </div>
    </div>
    <!-- Section Header End -->

    <!-- Section Content -->
    <div class="box-grey">
        <div class="wrapper">
            <div class="row margin-none col-half">
                <div class="col-md-4 col-sm-12 half padding-all">
                    <!-- <p><img src="assets/img/works-1-big.png" alt="Services" class="img-full"></p> -->
                    <h1 class="title-big letter-spacing line-bottom left">अभिप्राय</h1>
                    <p>तुम्ही दिलेला अभिप्राय हा आमच्या साठी मौल्यवान आहे. जेणेंकरू आम्ही आमच्या सेवेत सुधारणा करून सभासदांना यौग्य सेवा पुरवू शकू धन्यवाद.</p>
                    <div class="space "></div>
                    <p><a routerLink="/contact " class="btn btn-dark letter-spacing ">संपर्क</a></p>
                </div>
                <div class="col-md-8 col-sm-12 half padding-all box-white ">
                    <div class="grid-list">
                        <div class="row margin-none ">
                            <!-- Grid Col -->
                            <div class="col-md-12 col-sm-12 ">
                                <div class="data-form text-left">
                                    <app-alert></app-alert>
                                    <!-- (ngSubmit)="userRegister()" -->
                                    <form [formGroup]="feedBackForm" (ngSubmit)="feedback()">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12">
                                                <label>Name</label>
                                                <div class="form-field">
                                                    <i class="fa fa-user"></i>
                                                    <input type="text" formControlName="nmpk_feedBackName" name="name" placeholder="Enter your name" required>
                                                    <small class="text-danger" *ngIf="!feedBackForm.get('nmpk_feedBackName').valid && feedBackForm.get('nmpk_feedBackName').touched">
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBackName').errors['required']">Please enter full name.</span>
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBackName').errors['minlength']">Please enter at list 3 characters.</span>
                                                    </small>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-sm-12">
                                                <label>E-Mail</label>
                                                <div class="form-field">
                                                    <i class="fa fa-envelope-o"></i>
                                                    <input type="email" formControlName="nmpk_feedBackEmail" name="name" placeholder="Enter your email" required>
                                                    <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                                                    <small class="text-danger" *ngIf="!feedBackForm.get('nmpk_feedBackEmail').valid && feedBackForm.get('nmpk_feedBackEmail').touched"><i class="fa fa-envelope"></i> Please enter valid email.</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12">
                                                <label>Mobile No.</label>
                                                <div class="form-field">
                                                    <i class="fa fa-phone"></i>
                                                    <input type="tel" name="name" formControlName="nmpk_feedBackMobile" placeholder="Enter your mobile" required>
                                                    <small class="text-danger" *ngIf="!feedBackForm.get('nmpk_feedBackMobile').valid && feedBackForm.get('nmpk_feedBackMobile').touched">
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBackMobile').errors['required']"><i class="fa fa-phone"></i> Please enter mobile no.</span>
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBackMobile').errors['maxlength']"><i class="fa fa-phone"></i> Please enter 10 digit mobile no.</span>
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBackMobile').errors['minlength']"><i class="fa fa-phone"></i> Please enter 10 digit mobile no.</span>
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBackMobile').errors['pattern']"><i class="fa fa-phone"></i> Please enter numerically value.</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 col-sm-12">
                                                <label>Message</label>
                                                <div class="form-field">
                                                    <i class="fa fa-pencil-square-o"></i>
                                                    <textarea name="name" formControlName="nmpk_feedBack" placeholder="Enter your message" required></textarea>
                                                    <small class="text-danger" *ngIf="!feedBackForm.get('nmpk_feedBack').valid && feedBackForm.get('nmpk_feedBack').touched">
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBack').errors['required']"><i class="fa fa-phone"></i> Please enter feedback.</span>
                                                      <span *ngIf="feedBackForm.get('nmpk_feedBack').errors['minlength']">Please enter at list 50 characters.</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 col-sm-12">
                                                <input type="submit" class="btn btn-default" value="SEND YOUR MESSAGE">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- Grid Col End-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->
</section>